import { Injector, } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { filterNullOrUndefined } from '@utils/rxjs.utils';
import { Setting, } from 'main/app-state/current-user/settings';
import { combineLatest, forkJoin, of, } from 'rxjs';
import { catchError, filter, pairwise, pluck, repeatWhen, switchMap, takeUntil, tap, } from 'rxjs/operators';
import { AuthConfigManager, } from './auth-config';
import { CurrentUserManager, } from './current-user';
import { LanguageManager } from './language/language.manager';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/core";
var AppStateFacade = /** @class */ (function () {
    function AppStateFacade(injector, dateAdapter) {
        this._isInitialized = false;
        this._authConfig = new AuthConfigManager(injector);
        this._currentUser = new CurrentUserManager(injector);
        this._language = new LanguageManager(injector, this, dateAdapter);
    }
    Object.defineProperty(AppStateFacade.prototype, "user", {
        get: function () {
            return this._currentUser;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppStateFacade.prototype, "authConfig", {
        get: function () {
            return this._authConfig;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppStateFacade.prototype, "settings", {
        get: function () {
            return this._currentUser.settings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppStateFacade.prototype, "language", {
        get: function () {
            return this._language;
        },
        enumerable: true,
        configurable: true
    });
    AppStateFacade.prototype.initialize = function () {
        var _this = this;
        if (this._isInitialized) {
            return of(true);
        }
        return forkJoin([
            this._authConfig.fetch(),
            this._currentUser.fetch(),
        ])
            .pipe(tap(function (_) { return _this._isInitialized = true; }), switchMap(function () { return _this._language.initialize(); }), tap(function () { return _this._linkStates(); }), catchError(function (error) {
            error.isSeed = true;
            throw error;
        }));
    };
    /**
     * Set dependencies between the states of non-hierarchical managers.
     */
    AppStateFacade.prototype._linkStates = function () {
        var _this = this;
        var currentCultureChange$ = this._currentUser.settings
            .get$(Setting.currentCulture)
            .pipe(filter(function (lang) { return !!lang; }));
        var userLogin$ = this.user.value$.pipe(pairwise(), filter(function (_a) {
            var prev = _a[0], next = _a[1];
            return !prev && !!next;
        }));
        var userLogout$ = this.user.value$.pipe(pairwise(), filter(function (_a) {
            var prev = _a[0], next = _a[1];
            return !!prev && !next;
        }));
        // State links that are relevant only when the user is logged in.
        combineLatest([
            // Keep the displayed language in sync with the current culture user setting.
            currentCultureChange$.pipe(switchMap(function (lang) { return _this._language.set(lang); })),
            this._currentUser.folder.value$.pipe(filterNullOrUndefined(), 
            // Combine value$ with pairwise to prevent emitting when both Folder and Permissions managers are initialized on login.
            // Using value$ instead of change$ also prevents double GetCurrentPermissions requests when logging out and then back in.
            pairwise(), switchMap(function () {
                return _this._currentUser.permissions.fetch();
            })),
            this._currentUser.permissions.change$.pipe(tap(function (_) { return _this.user.folderPermissions.flushCache(); })),
        ]).pipe(
        // tslint:disable-next-line: rxjs-no-unsafe-takeuntil
        takeUntil(userLogout$), repeatWhen(function () { return userLogin$; })).subscribe();
        // State links that don't depend on user auth state.
        userLogout$.pipe(switchMap(function () { return _this._authConfig.fetch(); }), pluck('currentCulture'), switchMap(function (lang) { return _this._language.set(lang); })).subscribe();
    };
    AppStateFacade.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppStateFacade_Factory() { return new AppStateFacade(i0.ɵɵinject(i0.INJECTOR), i0.ɵɵinject(i1.DateAdapter)); }, token: AppStateFacade, providedIn: "root" });
    return AppStateFacade;
}());
export { AppStateFacade };
